// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2DaXo","label":"Section_label__2QnOq","contentWrap":"Section_contentWrap__84zpN","footer":"Section_footer__3VYj-","footerInner":"Section_footerInner__l7fmC"};